import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ITableContactParams {
  contactId: string;
  contactType: string;
  ids: string[];
}

export class SetTablesContactRequest extends Request<ITableContactParams, IResult> {
    constructor(params: ITableContactParams) {
      super('setTablesContact', params);
    }
  }
